import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import FieldConfigList from '../../components/fieldconfigmng/FieldConfigList';
import * as fieldConfigApi from '../../lib/api/fieldConfig';

const FieldConfigContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [selectedModule, setSelectedModule] = useState('CHANCE');
  const [fieldConfigs, setFieldConfigs] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);

  // 모듈별 필드 목록 조회
  const fetchFieldConfigs = async (moduleCd) => {
    setLoading(true);
    try {
      const response = await fieldConfigApi.getFieldConfigs(moduleCd);
      setFieldConfigs(response.data.list || []);
      setHasChanges(false);
    } catch (error) {
      console.error('Failed to fetch field configs:', error);
      enqueueSnackbar('필드 설정 조회에 실패했습니다.', { variant: 'error' });
      setFieldConfigs([]);
    } finally {
      setLoading(false);
    }
  };

  // 모듈 변경 시
  useEffect(() => {
    if (selectedModule) {
      fetchFieldConfigs(selectedModule);
    }
  }, [selectedModule]);

  // 모듈 선택 핸들러
  const handleModuleChange = (moduleCd) => {
    if (hasChanges) {
      if (window.confirm('저장하지 않은 변경사항이 있습니다. 모듈을 변경하시겠습니까?')) {
        setSelectedModule(moduleCd);
      }
    } else {
      setSelectedModule(moduleCd);
    }
  };

  // 필드 설정 변경 핸들러
  const handleFieldChange = (fieldConfigUuid, field, value) => {
    setFieldConfigs(prev => 
      prev.map(config => 
        config.fieldConfigUuid === fieldConfigUuid 
          ? { ...config, [field]: value }
          : config
      )
    );
    setHasChanges(true);
  };

  // 전체 저장
  const handleSave = async () => {
    if (!fieldConfigs || fieldConfigs.length === 0) {
      enqueueSnackbar('저장할 데이터가 없습니다.', { variant: 'warning' });
      return;
    }

    setLoading(true);
    try {
      await fieldConfigApi.updateFieldConfigs(fieldConfigs);
      enqueueSnackbar('필드 설정이 저장되었습니다.', { variant: 'success' });
      setHasChanges(false);
      // 저장 후 다시 조회
      await fetchFieldConfigs(selectedModule);
    } catch (error) {
      console.error('Failed to save field configs:', error);
      enqueueSnackbar('저장에 실패했습니다.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // 초기화 (다시 조회)
  const handleReset = () => {
    if (window.confirm('변경사항을 취소하고 다시 불러오시겠습니까?')) {
      fetchFieldConfigs(selectedModule);
    }
  };

  return (
    <FieldConfigList
      selectedModule={selectedModule}
      fieldConfigs={fieldConfigs}
      loading={loading}
      hasChanges={hasChanges}
      onModuleChange={handleModuleChange}
      onFieldChange={handleFieldChange}
      onSave={handleSave}
      onReset={handleReset}
    />
  );
};

export default FieldConfigContainer;
